import React from "react";
import { Outlet } from "react-router-dom";
const LeadManagementRoot = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default LeadManagementRoot;
